export const EDITOR_CONSTS = {
  deleteMsg: 'Удалить',
  descriptionLabelMsg: 'Описание',
  regionLabelMsg: 'Выберите регион(ы)',
  imageTooltipMsg: 'Нажмите сюда для выбора фото',
  imageNotExists: 'Фотографии нет',
  insertMsg: 'Вставить',
  insertingAPhotoMsg: 'Вставка фото',
  inStoryDescription: 'в описании сюжета',
  inStoryTitle: 'в заголовке сюжета',
  maxDescriptionLength: 500,
  maxTitleLength: 120,
  titleLabelMsg: 'Название',
  defaultImage: {
    id: 'storyEditFigureId',
    src: '',
    cropperPreviewUrl: '',
    crop: {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    },
    figureId: '',
    figureUid: '',
    figureVersionId: '',
    isFullWidth: true,
    isannouncingphoto: false,
    isoverviewblock: false,
    hasWatermark: false,
    hasDiagonalWatermark: false
  }
}
